import React, { useId } from 'react';
import '../../css/fila-ajuste.css';

/**
 * Una fila de ajustes: a la izquierda qué es y para qué sirve, a la derecha
 * los controles. Las filas se separan con una línea fina, sin tarjetas
 * anidadas, para que cada pestaña se lea de arriba abajo como una sola hoja.
 * La usan el perfil propio y la ficha de usuario del panel de gestión.
 *
 * @param peligro  título en rojo, para acciones que no tienen vuelta atrás
 * @param ancho    los controles usan toda la columna (listas, matrices)
 */
const FilaAjuste = ({ titulo, texto, extra, peligro = false, ancho = false, children }) => {
  const idTitulo = useId();

  return (
    <div className={`fila-ajuste${peligro ? ' fila-ajuste--peligro' : ''}`} role="group" aria-labelledby={idTitulo}>
      <div className="fila-ajuste-texto">
        <h3 id={idTitulo}>{titulo}</h3>
        {texto && <p>{texto}</p>}
        {extra}
      </div>
      <div className={`fila-ajuste-control${ancho ? ' fila-ajuste-control--ancho' : ''}`}>{children}</div>
    </div>
  );
};

export default FilaAjuste;
